import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useDripsyTheme } from "../use-dripsy-theme";
import { useBreakpointIndex } from "./breakpoint-context";
import { mapPropsToStyledComponent } from "./map-props";
import { useStableMemo } from "../utils/use-stable-memo";
export function createThemedComponent(Component) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var baseStyle = _param.defaultStyle, options = _object_without_properties(_param, [
        "defaultStyle"
    ]);
    var WrappedComponent = /*#__PURE__*/ React.forwardRef(function Wrapped(prop, ref) {
        var _sx = prop.sx, as = prop.as, variant = prop.variant, style = prop.style, themeKey = prop.themeKey, _prop_variants = prop.variants, variants = _prop_variants === void 0 ? options.defaultVariants : _prop_variants, props = _object_without_properties(prop, [
            "sx",
            "as",
            "variant",
            "style",
            "themeKey",
            "variants"
        ]);
        if (typeof __DEV__ !== "undefined" && typeof as === "string") {
            console.error('[dripsy] Looks like you used an invalid "as" prop. "'.concat(as, "\" can't be a string. Please pass a valid React component. HTML elements are not supported."));
        }
        var defaultStyle = typeof baseStyle == "function" ? baseStyle(prop) : baseStyle;
        var theme = useDripsyTheme().theme;
        // make the sx factory out here so that it's a stable dependency for useStableMemo
        var sx = typeof _sx == "function" ? _sx(theme) : _sx;
        var breakpoint = useBreakpointIndex();
        var styles = useStableMemo(function() {
            return mapPropsToStyledComponent({
                theme: theme,
                breakpoint: breakpoint,
                variant: variant,
                sx: sx,
                style: style,
                variants: variants
            }, _object_spread_props(_object_spread({}, options), {
                themeKey: themeKey !== null && themeKey !== void 0 ? themeKey : options.themeKey,
                defaultStyle: defaultStyle
            }));
        }, [
            theme,
            breakpoint,
            variant,
            sx,
            style,
            variants,
            themeKey,
            defaultStyle
        ]).styles;
        var TheComponent = as || Component;
        return /*#__PURE__*/ _jsx(TheComponent, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            style: styles,
            variant: variant || options.defaultVariant
        }));
    });
    var _Component_displayName;
    WrappedComponent.displayName = "Dripsy.".concat((_Component_displayName = Component === null || Component === void 0 ? void 0 : Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : "NoNameComponent");
    return WrappedComponent;
}
